export function formatChf(amount) {
    if (typeof amount !== 'number') {
        amount = Number(amount);
        if (isNaN(amount)) return '- CHF';
    }

    return `${new Intl.NumberFormat('de-CH', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        useGrouping: true,
    }).format(amount)} CHF`;
}